import PerksListContainer from './PerksListContainer';

export default PerksListContainer;
